import React from "react";

export default function GrowPage() {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <div
        style={{
          fontSize: "1.1rem",
          lineHeight: "1.6",
          textAlign: "justify",
          padding: "0 1.5rem",
        }}
      >
        <p>Please help me grow the collection!</p>

        <p>
          If you have any AOL disks that do not appear in these pages, I'd be
          forever grateful for any contributions to my site. For any disks
          donated, I will add a tag, such as:
        </p>

        <p>
          <em>"Michael K." or "Michelle K." donated this disk!"</em> or whatever
          string the donator requests. If donated anonymously, I'll just add an{" "}
          <em>"Anonymous donation"</em> tag.
        </p>

        <p>
          If you'd like to donate disks, or just have comments or suggestions
          for the site, please contact me at this email address:
        </p>

        <p>
          <a
            href="mailto:aoldiskcollector@gmail.com"
            style={{
              fontWeight: "bold",
              color: "#88b4e7", // medium blue for readability
            }}
          >
            aoldiskcollector@gmail.com
          </a>
        </p>

        <p>I check this account daily, so responses will be prompt.</p>

        <p>Many Thanks and I hope you enjoy the site!</p>

        <p>bl</p>
      </div>

      <p style={{ marginTop: "2rem", textAlign: "center", fontStyle: "italic" }}>
        🚀 Stay tuned — the collection is only getting bigger!
      </p>
    </div>
  );
}
